/*
This is the menu that is activated when user clicks on a 
single bar in a chart in the time tab.
*/

import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { modifyQuery } from "./helpers/overviewUrl";
import Menu, { MenuItem } from "material-ui/Menu";

const OvTimeBarMenu = props => {
  const { anchorEl, open, filterState, period, onClose, history } = props;

  const handleNavDrilldown = () => {
    const path = modifyQuery(filterState, "time", {
      period,
      simpleParams: {
        granularity: "AUTO_100"
      }
    });

    history.push(path);
    onClose();
  };

  const handleNavAccountBreakdown = () => {
    const path = modifyQuery(filterState, "accounts", {
      period
    });
    history.push(path);
    onClose();
  };

  return (
    <Menu anchorEl={anchorEl} open={open} onRequestClose={onClose}>
      <MenuItem dense onClick={handleNavDrilldown}>
        Expand this date range
      </MenuItem>
      <MenuItem dense onClick={handleNavAccountBreakdown}>
        Accounts breakdown for this date range
      </MenuItem>
      <MenuItem dense onClick={onClose}>
        Close
      </MenuItem>
    </Menu>
  );
};

OvTimeBarMenu.propTypes = {
  anchorEl: PropTypes.object,
  open: PropTypes.bool.isRequired,
  granularity: PropTypes.object.isRequired,
  filterState: PropTypes.object.isRequired,
  period: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired
};

export { OvTimeBarMenu };

export default withRouter(OvTimeBarMenu);



// WEBPACK FOOTER //
// ./src/OvTimeBarMenu.js